<template>
  <div class="panel-container two-panel-3-7-tabs">
    <div class="panel">
      <customer-list @storechanged='handleStoreChange($event)' :click-item='clickItem' :customers='customers' :search-mode='searchMode'
        :list-loading='listLoading' @submitsearch='handleSubmitSearch($event)' :selected-customer='customerObj' :allowed-stores='User.AllowedStores'
        :report-mode='reportMode' :selected-platform='storePlatform'/>
    </div>
    <div class="panel">
      <customer-profile v-if='isLoggedIn && customerObj' :customer-obj='customerObj' :user='User' />
    </div>
  </div>
</template>

<script>
  import {
    webAuth
  } from '@/auth/index'
  import {
    mapGetters
  } from 'vuex'
  import {
    CustomerAPIClient
  } from '@/lib/data_access/Customer';
  import CustomerProfile from '@/components/CustomerProfile/CustomerProfile.vue'
  import CustomerList from '@/components/CustomerList/CustomerList.vue'
  import {
    relativeTimeThreshold
  } from 'moment';
  export default {
    name: 'home',
    computed: {
      ...mapGetters(['authToken', 'User']),
      storePlatform: function (){
        let vm = this;
        console.log(vm.storeInput)
        if(vm.storeInput){
          return vm.storeInput
        }
        else
        {
          return vm.User.AllowedStores[0].AccountPlatformID
        }
      }
    },
    data() {
      return {
        user: {},
        isLoggedIn: webAuth.user.isLoggedIn,
        loading: false,
        customerObj: null,
        customers: null,
        searchMode: false,
        listLoading: false,
        reportMode: false,
        storeInput: null
      }
    },
    created() {
      let vm = this;
      let reportType = vm.$route.query.report
      vm.listLoading = true;
      loadReport(reportType, vm.storePlatform).then(function (data) {
        vm.customers = data
        if (vm.customers.length > 0) {
          vm.customerObj = Object.assign({}, data[0].CustomerIds)
        }
        if (reportType && reportType.toLowerCase() == 'search') {
          vm.searchMode = true;
        } else {
          vm.searchMode = false;
        }

        if (reportType.toLowerCase == 'search' || reportType.toLowerCase() == 'recent') {
          vm.reportMode = false
        } else {
          vm.reportMode = true;
        }

        vm.listLoading = false;
      }).catch(function () {
        vm.customers = []
        vm.listLoading = false
      })
    },
    watch: {
      '$route.query.report': function (newVal) {
        let vm = this;
        let promise;
        vm.listLoading = true
        if (newVal) {
          loadReport(newVal, vm.storePlatform).then(function (data) {
            vm.customers = data
            vm.listLoading = false
          }).catch(function () {
            vm.customers = []
            vm.listLoading = false
          })

          if (newVal.toLowerCase() == 'search') {
            vm.searchMode = true;
          } else {
            vm.searchMode = false;
          }

          if (newVal.toLowerCase == 'search' || newVal.toLowerCase() == 'recent') {
            vm.reportMode = false
          } else {
            vm.reportMode = true;
          }
        }
      }
    },
    methods: {
      clickItem(customer) {
        let vm = this;
        vm.customerObj = Object.assign({}, customer)
      },
      handleSubmitSearch(searchTerm) {
        let vm = this;
        vm.listLoading = true;
        CustomerAPIClient.postPatternSearch(searchTerm).then(function (data) {

          vm.customers = data;
          vm.listLoading = false
        })
      },
      handleStoreChange(platformId) {
        let vm = this;
        vm.storePlatform = platformId
        loadReport(vm.$route.query.report, platformId).then(function (data) {
          console.log(data)
            vm.customers = data
            vm.listLoading = false
            })
        }

      },
      components: {
        CustomerProfile,
        CustomerList
      }
    }

    function loadReport(newVal, platformId) {
      let promise;
      switch (newVal) {
        case 'highIntensity':
          promise = CustomerAPIClient.getHighIntensityActiveLeadsReport(platformId)
          break
        case 'losingIntensity':
          promise = CustomerAPIClient.getActiveLeadsLosingIntensityReport(platformId)
          break
        case 'lostLeads':
          promise = CustomerAPIClient.getLostLeadsInMarketReport(platformId)
          break
        case 'soldBim':
          promise = CustomerAPIClient.getSoldCustomersBackInMarketReport(platformId)
          break;
        case 'search':
          promise = new Promise((resolve, reject) => {
            resolve([])
          });
          break;
        case 'recent':
        default:
          promise = CustomerAPIClient.getRecentlyViewedReport()
          break;
      }
      return promise;
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
  @import '../../../styles/_panels.scss';

  table#customer-list {
    tr {

      td:first-child {
        border-left: 5px solid $white;
      }
      &.new-sales {
        td:first-child {
          border-left: 5px solid $blue-lt;
        }
      }
      &.used-sales {
        td:first-child {
          border-left: 5px solid $orange;
        }
      }
    }
  }

  .cust-name {
    vertical-align: middle;
  }

  .content-row-timestamp {
    width: 55px;
    text-align: right;
    font-size: 11px;
    line-height: 15px;
    height: 15px;
    margin-top: 4px;
  }

  .sticky-top {
    background: $white;
    box-shadow: 1px 1px 0px $gray-lt;
    top: -1px;
  }

</style>



// WEBPACK FOOTER //
// src/views/Web/Home.vue